import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Modal,
  Input,
  DatePicker,
  Button,
  Card,
  Divider,
  Row,
  Col,
  Badge,
  Popconfirm,
  Checkbox,
  ConfigProvider,
  Tooltip,
} from "antd";
import { SearchOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import "dayjs/locale/bg"; // Import Bulgarian locale
import localizedFormat from "dayjs/plugin/localizedFormat";
import bgBG from "antd/lib/locale/bg_BG";
import { useProjectState } from "../../../../context/stateContext";
import reservationsActions from "../../../../redux/reservations/actions";
import CloseButton from "../../../Common/CloseButton/CloseButton";
import "./index.css";

dayjs.extend(localizedFormat);

// Set the locale to Bulgarian
dayjs.locale("bg");

const {
  createReservationGetTables,
  createReservation,
  getTablesAndReservationPerRegion,
  createReservationClientHistory,
} = reservationsActions;

const CreateReservationNewModal = ({ regionId, date }) => {
  const {
    // When we have clickedTableForReservation that means that we open modal from click on table and then click on open reservation
    clickedTableForReservation,
    setClickedTableForReservation,
    // When we have selectedTimeForReservation that means that we open modal from /reservation-overview
    setSelectedTimeForReservation,
    selectedTimeForReservation,
  } = useProjectState();

  const dispatch = useDispatch();

  const { freeTables, openCreateReservationModal, userReservationHistory } =
    useSelector((state) => state.restaurantReservationsReducer);
  const { regions } = useSelector((state) => state.restaurantSchemaReducer);

  const increaseGuestCount = () => {
    setGuestCount(guestCount + 1);
  };

  const declineGuestCount = () => {
    let newCount = guestCount - 1;
    if (newCount < 0) {
      newCount = 0;
    }
    setGuestCount(newCount);
  };

  const increaseDuration = () => {
    setDuration(duration + 1);
  };

  const declineDuration = () => {
    let newCount = duration - 1;
    if (newCount < 0) {
      newCount = 0;
    }
    setDuration(newCount);
  };

  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [selectedHour, setSelectedHour] = useState("");
  const [selectedMins, setSelectedMins] = useState("");
  const [selectedTables, setSelectedTables] = useState([]);
  const [name, setName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [clientNote, setClientNote] = useState("");
  const [guestCount, setGuestCount] = useState(2);
  const [duration, setDuration] = useState(1);
  const [note, setNote] = useState("");
  const [currentRegionKey, setCurrentRegionKey] = useState(regionId);
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const [sendSms, setSendSms] = useState(false);
  const [deposit, setDeposit] = useState("");
  const [isNameFromHistory, setIsNameFromHistory] = useState(false);
  const [isClientNoteFromHistory, setIsClientNoteFromHistory] = useState(false);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const setToday = () => {
    const today = dayjs();
    setSelectedDate(today);
  };

  const setTomorrow = () => {
    const tomorrow = dayjs().add(1, "day");
    setSelectedDate(tomorrow);
  };

  const hours = [
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
  ];

  const minutes = ["00", "30"];

  const handleSelectHourClick = (hour) => {
    setSelectedHour(hour);
    setSelectedTables([]);
    setClickedTableForReservation([]);
  };

  const handleSelectMinsClick = (mins) => {
    setSelectedMins(mins);
    setSelectedTables([]);
    setClickedTableForReservation([]);
  };

  const handleSelectTablesClick = (table) => {
    setSelectedTables((prevSelectedTables) => {
      // Check if the table is already selected
      if (prevSelectedTables.includes(table)) {
        // If already selected, remove it from the array
        return prevSelectedTables.filter((t) => t !== table);
      } else {
        // If not selected, add it to the array
        return [...prevSelectedTables, table];
      }
    });
  };

  const handleInputNameChange = (e) => {
    setName(e.target.value);
  };

  const handleInputPhoneNumberChange = (e) => {
    setPhoneNumber(e.target.value);
    // Reset fields when phone number changes
    if (isNameFromHistory) {
      setName("");
      setIsNameFromHistory(false);
    }
    if (isClientNoteFromHistory) {
      setClientNote("");
      setIsClientNoteFromHistory(false);
    }
  };

  const handleInputClientNoteChange = (e) => {
    setClientNote(e.target.value);
  };

  const handleInputNoteChange = (e) => {
    setNote(e.target.value);
  };

  const disabledDate = (current) => {
    return current && current < dayjs().startOf("day");
  };

  const clearInitialState = () => {
    setSelectedDate(dayjs());
    setSelectedHour("");
    setSelectedMins("");
    setSelectedTables([]);
    setName("");
    setPhoneNumber("");
    setClientNote("");
    setGuestCount(2);
    setDuration(1);
    setNote("");

    setClickedTableForReservation([]);
    setSelectedTimeForReservation("");

    setSendSms(false);
    setDeposit("");
    setIsNameFromHistory(false);
    setIsClientNoteFromHistory(false);
  };

  const closeModal = () => {
    clearInitialState();
    dispatch({
      type: "CLOSE_RESERVATION_CREATE_MODAL",
    });
  };

  const [validate, setValidate] = useState(false);

  const isOnlyIntegers = (str) => {
    if (str.length === 0) {
      return false;
    }
    const integerRegex = /^\d+$/;
    return integerRegex.test(str);
  };

  const handleAddRezervation = async () => {
    if (
      name !== "" &&
      phoneNumber !== "" &&
      isOnlyIntegers(phoneNumber) &&
      selectedTables.length > 0
    ) {
      await dispatch(
        createReservation({
          guestsCount: guestCount,
          regionId: currentRegionKey,
          duration: duration,
          reservationTime: `${selectedHour}:${selectedMins}:00`,
          reservationDate: selectedDate.format("YYYY-MM-DD"),
          name: name,
          phone: phoneNumber,
          clientNote: clientNote,
          note: note,
          organizationId: parseInt(localStorage.getItem("organizationId")),
          TouchSaleTablesIds: selectedTables,
          date: date,
          sendSms: sendSms,
          deposit: deposit !== "" ? parseFloat(deposit) : 0,
        })
      );

      await new Promise((resolve) => setTimeout(resolve, 500));

      if (selectedTimeForReservation !== "") {
        await dispatch(
          getTablesAndReservationPerRegion({
            organizationId: parseInt(localStorage.getItem("organizationId")),
            regionId: regionId,
            date: date.format("YYYY-MM-DD"),
          })
        );
      }

      setValidate(false);
    } else {
      setValidate(true);
    }
  };

  useEffect(() => {
    if (openCreateReservationModal === false) {
      // in this case we expect that modal is close after create a new reservation
      clearInitialState();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openCreateReservationModal]);

  useEffect(() => {
    // Handler to call on window resize
    const handleResize = () => {
      setWindowSize(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (selectedDate && selectedMins && selectedHour) {
      dispatch(
        createReservationGetTables({
          organizationId: parseInt(localStorage.getItem("organizationId")),
          regionId: currentRegionKey,
          date: selectedDate.format("YYYY-MM-DD"),
          time: `${selectedHour}:${selectedMins}`,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedDate,
    selectedHour,
    selectedMins,
    openCreateReservationModal,
    currentRegionKey,
  ]);

  useEffect(() => {
    if (!Array.isArray(clickedTableForReservation) && freeTables.length !== 0) {
      if (
        !selectedTables.some((table) => table === clickedTableForReservation)
      ) {
        const existTable = freeTables.some(
          (table) => table.touchSaleTableId === clickedTableForReservation
        );

        if (existTable) {
          setSelectedTables((prevSelectedTables) => {
            return [...prevSelectedTables, clickedTableForReservation];
          });
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clickedTableForReservation, freeTables]);

  useEffect(() => {
    if (selectedTimeForReservation !== "") {
      if (
        selectedDate.isSame(dayjs(), "day") &&
        (parseInt(dayjs().format("HH")) <=
          parseInt(selectedTimeForReservation.slice(0, 2)) ||
          (parseInt(selectedTimeForReservation.slice(0, 2)) ===
            parseInt(dayjs().format("HH")) &&
            parseInt(dayjs().format("mm")) < 45))
      ) {
        setSelectedHour(selectedTimeForReservation.slice(0, 2));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedTimeForReservation]);

  useEffect(() => {
    if (selectedHour !== "") {
      if (
        selectedDate.isSame(dayjs(), "day") &&
        dayjs(
          `${selectedHour}:${selectedTimeForReservation.slice(3, 5)}`,
          "HH:mm"
        ).isAfter(dayjs())
      ) {
        setSelectedMins(selectedTimeForReservation.slice(3, 5));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedHour]);

  useEffect(() => {
    setSelectedDate(date);
  }, [date]);

  // Auto-fill name and clientNote from userReservationHistory
  useEffect(() => {
    if (
      userReservationHistory &&
      Object.keys(userReservationHistory).length > 0
    ) {
      // Check if user has data (not just empty response)
      if (
        userReservationHistory.name !== null &&
        userReservationHistory.name !== undefined
      ) {
        setName(userReservationHistory.name);
        setIsNameFromHistory(true);
      } else {
        // If name is null, clear and enable the field
        setName("");
        setIsNameFromHistory(false);
      }

      if (
        userReservationHistory.clientNote !== null &&
        userReservationHistory.clientNote !== undefined
      ) {
        setClientNote(userReservationHistory.clientNote);
        setIsClientNoteFromHistory(true);
      } else {
        // If clientNote is null, clear and enable the field
        setClientNote("");
        setIsClientNoteFromHistory(false);
      }
    }
  }, [userReservationHistory]);

  // Prevent scrolling the entiry page
  useEffect(() => {
    if (openCreateReservationModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [openCreateReservationModal]);

  return (
    <ConfigProvider locale={bgBG}>
      <Modal
        closeIcon={<CloseButton />}
        title="Създаване на резервация"
        open={openCreateReservationModal}
        onOk={handleAddRezervation}
        onCancel={closeModal}
        className="reservation-modal reservation-create-modal"
        footer={null}
        width={windowSize >= 767 ? "1040px" : "520px"}
      >
        <div className="create-reservation-modal-main-header-container">
          <div className="create-reservation-modal-main-header-dates">
            <Button
              size={windowSize <= 767 && "small"}
              onClick={setToday}
              className={`${
                selectedDate.isSame(dayjs(), "day")
                  ? "create-reservation-modal-button-border"
                  : ""
              } `}
            >
              Днес
            </Button>
            <Button
              size={windowSize <= 767 && "small"}
              onClick={setTomorrow}
              className={`${
                selectedDate.isSame(dayjs().add(1, "day"), "day")
                  ? "create-reservation-modal-button-border"
                  : ""
              } `}
            >
              Утре
            </Button>
            <DatePicker
              className={`create-reservation-modal-date-picker ${
                !selectedDate.isSame(dayjs(), "day") &&
                !selectedDate.isSame(dayjs().add(1, "day"), "day")
                  ? "create-reservation-modal-button-border create-reservation-modal-date-picker-text-color"
                  : ""
              }`}
              size={windowSize <= 767 && "small"}
              format="dddd, D MMM"
              onChange={handleDateChange}
              value={selectedDate}
              disabledDate={disabledDate}
              inputReadOnly={true}
            />
          </div>
        </div>
        <div className="create-reservation-modal-select-time-container">
          <div>
            <Row gutter={16}>
              {hours.slice(0, 6).map((label, index) => (
                <Col key={index} span={windowSize <= 767 ? 3 : 4}>
                  <Button
                    size={windowSize <= 767 && "small"}
                    onClick={() => handleSelectHourClick(label)}
                    className={`${
                      label === selectedHour
                        ? "create-reservation-modal-button-border"
                        : ""
                    } `}
                    disabled={
                      selectedDate.isSame(dayjs(), "day") &&
                      (parseInt(label) < parseInt(dayjs().format("HH")) ||
                        (parseInt(label) === parseInt(dayjs().format("HH")) &&
                          parseInt(dayjs().format("mm")) > 45))
                    }
                  >
                    {label}
                  </Button>
                </Col>
              ))}
            </Row>
            <Row
              gutter={16}
              className="create-reservation-modal-select-time-second-row"
            >
              {hours.slice(6).map((label, index) => (
                <Col key={index} span={windowSize <= 767 ? 3 : 4}>
                  <Button
                    size={windowSize <= 767 && "small"}
                    onClick={() => handleSelectHourClick(label)}
                    className={`${
                      label === selectedHour
                        ? "create-reservation-modal-button-border"
                        : ""
                    } `}
                    disabled={
                      selectedDate.isSame(dayjs(), "day") &&
                      (parseInt(label) < parseInt(dayjs().format("HH")) ||
                        (parseInt(label) === parseInt(dayjs().format("HH")) &&
                          parseInt(dayjs().format("mm")) > 45))
                    }
                  >
                    {label}
                  </Button>
                </Col>
              ))}
            </Row>
            {validate && selectedHour === "" && (
              <p className="edit-reservation-modal-time-validation-message">
                Моля, изберете час
              </p>
            )}
          </div>
          <div>
            <Row gutter={16} style={{ justifyContent: "center" }}>
              {minutes.slice(0, 1).map((label, index) => (
                <Col key={index} span={windowSize <= 767 ? 9 : 10}>
                  <Button
                    size={windowSize <= 767 && "small"}
                    onClick={() => handleSelectMinsClick(label)}
                    className={`${
                      label === selectedMins
                        ? "create-reservation-modal-button-border"
                        : ""
                    } `}
                    disabled={
                      selectedDate.isSame(dayjs(), "day") &&
                      (selectedHour === "" ||
                        dayjs(`${selectedHour}:${label}`, "HH:mm").isBefore(
                          dayjs()
                        ))
                    }
                  >
                    {label}
                  </Button>
                </Col>
              ))}
            </Row>
            <Row
              gutter={16}
              style={{ justifyContent: "center" }}
              className="create-reservation-modal-select-time-second-row"
            >
              {minutes.slice(1).map((label, index) => (
                <Col key={index} span={windowSize <= 767 ? 9 : 10}>
                  <Button
                    size={windowSize <= 767 && "small"}
                    onClick={() => handleSelectMinsClick(label)}
                    className={`${
                      label === selectedMins
                        ? "create-reservation-modal-button-border"
                        : ""
                    } `}
                    disabled={
                      selectedDate.isSame(dayjs(), "day") &&
                      (selectedHour === "" ||
                        dayjs(`${selectedHour}:${label}`, "HH:mm").isBefore(
                          dayjs()
                        ))
                    }
                  >
                    {label}
                  </Button>
                </Col>
              ))}
            </Row>
            {validate && selectedMins === "" && (
              <p className="edit-reservation-modal-time-validation-message">
                Моля, изберете минути
              </p>
            )}
          </div>
        </div>
        <Divider />
        <div className="create-reservation-modal-select-duration-guest-container">
          <div className="create-reservation-modal-select-duration-guest-secondary-container">
            <span>Места</span>
            <div className="create-reservation-modal-select-duration-guest-element">
              <Button disabled={guestCount <= 1} onClick={declineGuestCount}>
                -
              </Button>
              {guestCount}

              <Button onClick={increaseGuestCount}>+</Button>
            </div>
          </div>

          <div className="create-reservation-modal-select-duration-guest-secondary-container">
            <span>Продължителност</span>
            <div className="create-reservation-modal-select-duration-guest-element">
              <Button disabled={duration <= 1} onClick={declineDuration}>
                -
              </Button>
              {duration}

              <Button onClick={increaseDuration} disabled={duration >= 14}>
                +
              </Button>
            </div>
          </div>
        </div>
        <Divider />
        <div className="reservation-modal-region-grid">
          {regions?.map((region) => (
            <Button
              key={region.key}
              type="default"
              className={`reservation-modal-region-button ${
                currentRegionKey === region.key ? "active" : ""
              }`}
              onClick={() => setCurrentRegionKey(region.key)}
            >
              {region.label}
            </Button>
          ))}
        </div>
        <div>
          {selectedHour !== "" && selectedMins !== "" && (
            <div className="reservation-modal-tables-grid">
              {freeTables.map((table, index) => (
                <div key={index}>
                  <Badge
                    count={table.seatsCount}
                    className="create-reservation-modal-select-table-card-badge"
                    style={{
                      backgroundColor: `${
                        table.seatsCount === guestCount &&
                        !table.activeReservation
                          ? "#7bb57b" // Recommend green if seatsCount equals guestCount
                          : table.seatsCount === guestCount + 1 &&
                            !freeTables.some(
                              (t) => t.seatsCount === guestCount
                            ) &&
                            !table.activeReservation
                          ? "#7bb57b" // Green if seatsCount equals guestCount + 1 and no table matches exactly with guestCount
                          : "rgb(229 229 229)" // Default grey means that they are not recommended
                      }`,
                      color: "#000000",
                    }}
                  >
                    <Card
                      onClick={() => {
                        if (table.activeReservation === false) {
                          handleSelectTablesClick(table.touchSaleTableId);
                        }
                      }}
                      style={{
                        background: `${
                          table.activeReservation === true
                            ? "#cccaca" // gray
                            : selectedTables.includes(table.touchSaleTableId)
                            ? "#1677ff" // blue
                            : "#e2efd9" // green
                        }`,
                        color: `${
                          selectedTables.includes(table.touchSaleTableId)
                            ? "#ffffff"
                            : ""
                        }`,
                      }}
                      className="create-reservation-modal-select-table-card"
                      bodyStyle={{
                        padding: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span className="create-reservation-modal-select-table-card-reservation-times">
                        {table.previousReservation?.slice(0, 5)}
                      </span>
                      <span className="create-reservation-modal-select-table-card-reservation-name">
                        {table.tableName}
                      </span>
                      <span className="create-reservation-modal-select-table-card-reservation-times">
                        {table.nextReservation?.slice(0, 5)}
                      </span>
                    </Card>
                  </Badge>
                </div>
              ))}
            </div>
          )}
        </div>
        {validate && selectedTables <= 0 && (
          <p className="create-reservation-modal-validation-message">
            Моля, изберете маса
          </p>
        )}

        <Divider />
        <div className="create-reservation-check-user-history">
          <Tooltip
            color="blue"
            placement="top"
            title={
              <div>
                <div>
                  {userReservationHistory.activeReservationsCount || 0}{" "}
                  резервации
                </div>
                <div>
                  {userReservationHistory.deletedReservationsCount || 0}{" "}
                  отказани
                </div>
                <div>
                  {userReservationHistory.averageBill?.toFixed(2) || "0.00"}{" "}
                  средна сметка
                </div>
              </div>
            }
            trigger="click"
          >
            <Button
              disabled={!isOnlyIntegers(phoneNumber)}
              size="small"
              icon={<SearchOutlined />}
              onClick={async () => {
                await dispatch(
                  createReservationClientHistory({
                    phone: phoneNumber,
                    organizationId: parseInt(
                      localStorage.getItem("organizationId")
                    ),
                  })
                );
              }}
            >
              Минали резервации
            </Button>
          </Tooltip>
        </div>
        <div className="create-reservation-modal-input-main-container">
          <div className="create-reservation-modal-input-main-container">
            <div className="create-reservation-modal-input-container">
              <span>Телефон:</span>
              <Input
                className="create-reservation-modal-input-element"
                type="tel"
                allowClear
                placeholder="0899995231"
                value={phoneNumber}
                onChange={handleInputPhoneNumberChange}
              />
            </div>
            {validate && !isOnlyIntegers(phoneNumber) && (
              <p className="create-reservation-modal-validation-message">
                Моля, въведете телефонен номер
              </p>
            )}
          </div>
          <div className="create-reservation-modal-input-container">
            <span>Име:</span>
            <Input
              className="create-reservation-modal-input-element"
              allowClear
              placeholder="Иван Иванов"
              value={name}
              onChange={handleInputNameChange}
              disabled={isNameFromHistory}
            />
          </div>
          {validate && name === "" && (
            <p className="create-reservation-modal-validation-message">
              Моля, въведете име
            </p>
          )}
        </div>

        <div className="create-reservation-modal-input-main-container">
          <div className="create-reservation-modal-input-container">
            <span>Инфо:</span>
            <Input
              className="create-reservation-modal-input-element"
              allowClear
              placeholder="Допълнителна информация"
              value={clientNote}
              onChange={handleInputClientNoteChange}
              disabled={isClientNoteFromHistory}
            />
          </div>
        </div>

        <div className="create-reservation-modal-input-container">
          <span>Забележка:</span>

          <Input.TextArea
            className="create-reservation-modal-input-element"
            allowClear
            value={note}
            onChange={handleInputNoteChange}
          />
        </div>

        <div className="create-reservation-modal-input-container">
          <span>Депозит:</span>
          <Input
            className="create-reservation-modal-input-element"
            type="number"
            min={0}
            step={0.01}
            allowClear
            placeholder="0.00"
            value={deposit}
            onChange={(e) => setDeposit(e.target.value)}
          />
        </div>

        <div className="create-reservation-action-button">
          {name !== "" &&
          phoneNumber !== "" &&
          isOnlyIntegers(phoneNumber) &&
          selectedTables.length > 0 ? (
            <Popconfirm
              title="Нова резервация"
              description={
                <div className="create-reservation-popconfirm-container">
                  <p>
                    За:{" "}
                    <b>
                      {dayjs(
                        `${selectedHour}:${selectedMins}-${selectedDate.format(
                          "DD.MM.YYYY"
                        )}`,
                        "HH:mm-DD.MM.YYYY"
                      )
                        .locale("bg") // Set locale to Bulgarian for day names
                        .format("HH:mm DD.MM.YYYY (dddd)")}
                    </b>
                  </p>
                  <p>
                    Маса:{" "}
                    <b>
                      {selectedTables.length > 0
                        ? selectedTables
                            .map((selectedTable) =>
                              freeTables
                                .filter(
                                  (table) =>
                                    table.touchSaleTableId === selectedTable
                                )
                                .map((table) => table.tableName)
                            )
                            .flat()
                            .join(", ")
                        : "-"}
                    </b>
                  </p>

                  <p>
                    Клиент:{" "}
                    <b>
                      {name || ""}, {phoneNumber || ""}
                    </b>
                  </p>

                  <p>
                    Брой хора: <b>{guestCount}</b>
                  </p>
                  <p>
                    Продължителност:{" "}
                    <b>
                      {duration} {duration === 1 ? "час" : "часа"}
                    </b>
                  </p>
                  <Checkbox
                    checked={sendSms}
                    onChange={(event) => setSendSms(event.target.checked)}
                  >
                    Изпрати SMS
                  </Checkbox>
                </div>
              }
              onConfirm={handleAddRezervation}
              onCancel={() => console.log("Cancelled")}
              okText="Запис"
              cancelText="Отказ"
              okButtonProps={{
                className:
                  "create-reservation-popconfirm-custom-confirm-button",
              }}
              cancelButtonProps={{
                className: "create-reservation-popconfirm-custom-cancel-button",
              }}
            >
              <Button type="primary">Създай</Button>
            </Popconfirm>
          ) : (
            <Button
              type="primary"
              onClick={() => {
                if (
                  name === "" ||
                  phoneNumber === "" ||
                  !isOnlyIntegers(phoneNumber) ||
                  selectedTables.length === 0
                ) {
                  setValidate(true);
                }
              }}
            >
              Създай
            </Button>
          )}
        </div>
      </Modal>
    </ConfigProvider>
  );
};

export default CreateReservationNewModal;
